import _isEmpty from 'lodash.isempty';

export function isEmpty<T = any>(value: T) {
  return _isEmpty(value);
}
